/**
 * Generate the tailwind shades with
 * @see https://www.tailwindshades.com/
 */

module.exports = {
	container: {
		center: true,
		padding: "15px",
	},
	extend: {
		screens: {
			sm: "640px",
			md: "768px",
			lg: "1024px",
			xl: "1330px",
			"2xl": "1330px",
			"lg-down": {
				max: "1329px",
			},
			"md-down": {
				max: "1023px",
			},
			"sm-down": {
				max: "767px",
			},
			"sm-only": {
				max: "669px",
			},
		},
		fontFamily: {
			sans: ["Catamaran", "Montserrat", "arial", "sans-serif"],
			heading: ["DaysOne", "Trebuchet MS", "Helvetica", "sans-serif"],
			daysone: ["DaysOne", "Trebuchet MS", "Helvetica", "sans-serif"],
			catamaran: ["Catamaran", "Montserrat", "arial", "sans-serif"],
		},
		colors: {
			transparent: "transparent",
			current: "currentColor",
			"body-background": "#ffffff",
			"body-text": "#333333",
			black: {
				DEFAULT: "#000000",
			},
			white: {
				DEFAULT: "#ffffff",
			},
			primary: {
				DEFAULT: "#031A89",
				50: "#818DC4",
				100: "#ECF5FD",
				200: "#8499FC",
				300: "#5D78FB",
				400: "#3557FB",
				500: "#0D35FA",
				600: "#0529D9",
				700: "#0422B1",
				800: "#031A89",
				900: "#021052",
				950: "#010A37",
				hover: "#818DC4",
			},
			secondary: {
				DEFAULT: "#95CDFF",
				50: "#FFFFFF",
				100: "#F1F8FF",
				200: "#D2EAFF",
				300: "#B4DBFF",
				400: "#95CDFF",
				500: "#76BFFF",
				600: "#58B0FF",
				700: "#39A2FF",
				800: "#1B93FF",
				900: "#0085FB",
				950: "#007DEC",
				light: "#CAE6FF",
				hover: "#CAE6FF",
			},
			accent: {
				DEFAULT: "#812C97",
				50: "#B95ED0",
				100: "#B352CD",
				200: "#A93AC6",
				300: "#9533AF",
				400: "#812C97",
				500: "#6D257F",
				600: "#591E68",
				700: "#441750",
				800: "#301038",
				900: "#1C0921",
				950: "#120615",
				hover: "#DFCAE5",
				light: "#E0CAE5",
			},
		},
		lineHeight: {
			heading: "1.27",
		},
		margin: {
			container: "15px",
		},
		borderRadius: {
			button: "23px",
		},
		boxShadow: {
			card: "0 10px 20px 0px rgba(0, 0, 0, 0.07)",
			callout: "0 10px 20px 0px rgba(0, 0, 0, 0.15)",
		},
		opacity: {
			15: ".15",
		},
	},
};
